import type React from 'react'
import styled from 'styled-components'

import { Typography } from '@components/ui/Typography'

import { KPIIndex } from './KPIIndex'

const KPIWrapperDiv = styled.div<{ $alignItems: 'center' | 'flex-start' }>`
  display: flex;
  padding: 10px 0;
  align-items: ${({ $alignItems }) => $alignItems};
  gap: 10px;
  min-height: 52px;

  & + & {
    margin-top: 5px;
    border-top: 1px solid ${({ theme }) => theme.colors.common.paperStroke};
  }
`
const KPIHeadingTypography = styled(Typography)`
  flex: 2;
  display: flex;
  align-items: center;
`

const KPIAmountDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
`

const ColoredTypography = styled(Typography)<{ $color: string }>`
  color: ${({ $color }) => $color};
  line-height: ${({ theme }) => theme.typography['700-sm'].lineHeight};
`

interface KPICardProps {
  amount: NonNullable<React.ReactNode>
  amountColor: string
  hideIndex?: boolean
  indexValue?: Nullable<number>
  title: NonNullable<React.ReactNode>
}

export function KPICard({ amount, amountColor, hideIndex = false, indexValue, title }: KPICardProps) {
  return (
    <KPIWrapperDiv $alignItems={hideIndex ? 'center' : 'flex-start'}>
      <KPIHeadingTypography size="700-sm" color="gray-80">
        {title}
      </KPIHeadingTypography>

      <KPIAmountDiv>
        <ColoredTypography $color={amountColor} size="700-md">
          {amount}
        </ColoredTypography>

        {!hideIndex && <KPIIndex value={indexValue} />}
      </KPIAmountDiv>
    </KPIWrapperDiv>
  )
}
